// Envia o lead para /api/lead, que grava na planilha e devolve o link do
// WhatsApp com a mensagem pronta.
export type LeadSource = "home" | "formulario";

export type LeadPayload = {
  name: string;
  phone: string;
  city: string;
  source: LeadSource;
  propertyType?: string;
  billValue?: string;
  billRange?: string;
  priorKnowledge?: string;
  pitch?: string;
};

export async function submitLead(payload: LeadPayload): Promise<string> {
  const response = await fetch("/api/lead", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  const contentType = response.headers.get("content-type") || "";
  if (!contentType.includes("application/json")) {
    const text = await response.text();
    throw new Error(
      `Erro do servidor (${response.status}): ${text.substring(0, 100)}...`
    );
  }

  const data = await response.json();
  if (!response.ok || !data.success || !data.whatsappUrl) {
    throw new Error(data.error || "Erro ao enviar formulário");
  }
  return data.whatsappUrl as string;
}
